export const storageKey = {
  token: 'token',
  tokenType: 'tokenType',
  enumData: 'enumData',
  instituteEnumData: 'instituteEnumData',
  cityState: 'cityStateData',
};
